export const ADD_USER_DATA_AFTER_LOGIN = "ADD_USER_DATA_AFTER_LOGIN";
export const ADD_USER_PERMISSION_AFTER_LOGIN = "ADD_USER_PERMISSION_AFTER_LOGIN";
